import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import Logo from './Logo';

function PrimeiroAcesso() {
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formatarDocumento = (valor) => {
    const n = valor.replace(/\D/g, '');
    if (n.length <= 11) {
      return n
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '$1-$2')
        .slice(0, 14);
    }
    return n
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18);
  };

  const handleDocumentoChange = (e) => setCnpj(formatarDocumento(e.target.value));
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleSenhaChange = (e) => setSenha(e.target.value);
  const handleConfirmarSenhaChange = (e) => setConfirmarSenha(e.target.value);
  const handleLogoClick = () => navigate('/');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    
    const documentoLimpo = cnpj.replace(/\D/g, '');
    
    // Validações
    if (!documentoLimpo) {
      setErro('CNPJ/CPF é obrigatório');
      return;
    }
    if (documentoLimpo.length !== 11 && documentoLimpo.length !== 14) {
      setErro('Digite um CPF válido (11 dígitos) ou CNPJ válido (14 dígitos)');
      return;
    }
    if (!email) {
      setErro('E-mail é obrigatório');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErro('Digite um e-mail válido');
      return;
    }
    if (!senha) {
      setErro('Senha é obrigatória');
      return;
    }
    if (senha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    if (senha !== confirmarSenha) {
      setErro('As senhas não coincidem');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('/api/primeiro-acesso', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          documento: documentoLimpo, 
          email: email,
          senha: senha 
        }),
      });
      
      const data = await response.json();
      
      if (data.ok) {
        setSucesso('Senha cadastrada com sucesso! Redirecionando para o login...');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } else {
        setErro(data.erro || 'Erro ao cadastrar senha. Tente novamente.');
      }
    } catch {
      setErro('Erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo-area">
          <Logo size="large" onClick={handleLogoClick} />
          <p className="login-subtitle">Primeiro Acesso</p>
        </div>
        <div className="login-form-area">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="cnpj">CNPJ/CPF</label>
              <input
                type="text"
                id="cnpj"
                value={cnpj}
                onChange={handleDocumentoChange}
                placeholder="00.000.000/0000-00"
                disabled={loading}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Digite seu e-mail para recuperação de senha"
                disabled={loading}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="senha">Nova Senha</label>
              <input
                type="password"
                id="senha"
                value={senha}
                onChange={handleSenhaChange}
                placeholder="Digite sua nova senha (mín. 6 caracteres)"
                disabled={loading}
                required
                minLength="6"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmarSenha">Confirmar Senha</label>
              <input
                type="password"
                id="confirmarSenha"
                value={confirmarSenha}
                onChange={handleConfirmarSenhaChange}
                placeholder="Confirme sua nova senha"
                disabled={loading}
                required
                minLength="6"
              />
            </div>
            
            {erro && <div className="erro-mensagem">{erro}</div>}
            {sucesso && <div className="sucesso-mensagem">{sucesso}</div>}
            
            <div className="form-buttons">
              <button 
                type="button" 
                className="btn-secondary" 
                onClick={() => navigate('/')}
                disabled={loading}
              >
                Voltar
              </button>
              <button type="submit" className="btn-login" disabled={loading}>
                {loading ? 'Cadastrando...' : 'Cadastrar Senha'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PrimeiroAcesso;
